import { useIntl } from "react-intl";

import testIds from "constants/testIds";
import Input from "components/v2/Input/Input";
import FormSectionLabel from "pages/shipper/RequestFormV2/components/FormSectionLabel/FormSectionLabel";
import { stopTestId } from "@RequestFormV2/utils/testIds";
import { useEmailPasteCleanup } from "@RequestFormV2/sections/Schedule/hooks/useEmailPasteCleanup";
import { StopContactSlice } from "@RequestFormV2/sections/Schedule/hooks/useStopContact";
import StopContactNameField from "@RequestFormV2/sections/Schedule/components/StopCard/ContactSection/StopContactNameField";

interface ContactSectionProps {
  contact: StopContactSlice;
  stopIndex: number;
}

export default function ContactSection({ contact, stopIndex }: ContactSectionProps) {
  const intl = useIntl();
  const { fieldPaths } = contact;
  const handleEmailPaste = useEmailPasteCleanup(fieldPaths.stop_contact_email);

  return (
    <div className="rfv2-form-section">
      <FormSectionLabel label={intl.formatMessage({ id: "general.contact", defaultMessage: "Contact" })} />

      <div className="rfv2-form-section__content">
        <div className="rfv2-contact-grid">
          <StopContactNameField contact={contact} stopIndex={stopIndex} />
          <Input
            name={fieldPaths.stop_contact_number}
            label={intl.formatMessage({ id: "general.phone", defaultMessage: "Phone" })}
            testId={stopTestId(testIds.REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_CONTACT_PHONE_PREFIX, stopIndex)}
          />
          <Input
            name={fieldPaths.stop_contact_email}
            label={intl.formatMessage({ id: "general.email", defaultMessage: "Email" })}
            onPaste={handleEmailPaste}
            testId={stopTestId(testIds.REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_CONTACT_EMAIL_PREFIX, stopIndex)}
          />
        </div>
      </div>
    </div>
  );
}
